import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence  } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const DashboardSidebar = ({ expanded, setExpanded }) => {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [activeMenuItem, setActiveMenuItem] = useState(() => {
      const path = location.pathname.split('/')[1];
      return path || 'dashboard';
    });
    const [hrDropdownOpen, setHrDropdownOpen] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
          const isMobileView = window.innerWidth < 768;
          setIsMobile(isMobileView);
          if (isMobileView) {
            setExpanded(false);
            setIsOpen(false);
          }
        };
    
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, [setExpanded]);

    const hrSubMenuItems = [
        { id: "attendance", path: "/attendance", title: "Attendance" },
        { id: "leave", path: "/hr/leave", title: "Leave Management" },
        { id: "loan", path: "/hr/loan", title: "Staff Loans" },
        { id: "onboard", path: "/hr/onboard", title: "Onboard Staff" },
        { id: "training", path: "/hr/training", title: "Training" },
      ];

  const menuItems = [
    { id: "dashboard", path: "/dashboard", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ), title: "Dashboard" },
    { id: "hr", path: "/hr", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ), title: "HR",
        hasSubmenu: true,
        submenuItems: hrSubMenuItems 
    },
    { id: "payroll", path: "/payroll", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ), title: "Payroll" },
    { id: "accounting", path: "/accounting", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ), title: "Accounting" },
    { id: "admin", path: "/admin", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" />
      </svg>
    ), title: "Administration" },
    { id: "reports", path: "/reports", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ), title: "Reports" },
    { id: "settings", path: "/settings", icon: (
      <svg className="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ), title: "Settings" },
  ];

  const sidebarVariants = {
    expanded: {
      width: "240px",
      x: 0,
      display: "block",
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeInOut"
      }
    },
    collapsed: {
      width: isMobile ? "0px" : "70px",
      x: isMobile ? "-100%" : 0,
        display: isMobile ? "none" : "block",
      transition: {
        type: "tween",
        duration: 0.3,
        ease: "easeInOut"
      }
    }
  };

  // const textVariants = {
  //   visible: { opacity: 1, x: 0, transition: { duration: 0.3, delay: 0.1 } },
  //   hidden: { opacity: 0, x: -10, transition: { duration: 0.3 } }
  // };

  const handleMenuClick = (itemId, hasSubmenu) => {
    if (hasSubmenu) {
      setHrDropdownOpen(!hrDropdownOpen);
    } else {
      setActiveMenuItem(itemId);
      if (isMobile) {
        setIsOpen(false);
      }
    }
  };

  const isHrActive = hrSubMenuItems.some(item => 
    location.pathname.startsWith(item.path)
  );

  // Mobile hamburger menu
  const MobileHeader = () => (
    <div className="md:hidden fixed top-0 left-0 right-0 h-16 flex items-center justify-between px-4 z-50">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 focus:outline-none"
        aria-label="Toggle menu"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          {isOpen ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          )}
        </svg>
      </button>
    </div>
  );


  const Overlay = () => (
    <AnimatePresence>
      {isMobile && isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black z-30"
        />
      )}
    </AnimatePresence>
  );

  const SidebarHeader = () => (
    <div className="p-4 flex items-center justify-between h-16 border-b border-primary-700">
      <AnimatePresence mode="wait">
        {(expanded || (isMobile && isOpen)) ? (
          <motion.img
            key="full-logo"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            src="/assets/Payrendr.png"
            alt="Payrendr"
            className="h-6 ml-10"
          />
        ) : (
          <motion.img
            key="icon-only"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            src="/assets/payrendricon.png"
            alt="Payrendr Icon"
            className="w-6 h-6"
          />
        )}
      </AnimatePresence>

      {!isMobile && (
        <motion.button
          onClick={() => setExpanded(!expanded)}
          className="p-1 rounded-full hover:bg-primary-700 focus:outline-none"
          animate={{ rotate: expanded ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          aria-label={expanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </motion.button>
      )}
    </div>
  );


  return (
    <>
      <MobileHeader />
      <Overlay />
      
      <motion.div
          variants={sidebarVariants}
          initial={isMobile ? "collapsed" : "expanded"}
          animate={isMobile ? (isOpen ? "expanded" : "collapsed") : (expanded ? "expanded" : "collapsed")}
          className={`
            fixed left-0 
            ${isMobile ? 'top-0' : 'top-0'} 
            bg-primary-800 
            text-white 
            font-source-sans-3 
            shadow-lg 
            z-40
            h-full
            ${isMobile && !isOpen ? 'hidden md:block' : ''}
          `}
        >
        <SidebarHeader />

        {/* Navigation menu */}
        <nav className="mt-6">
          <ul>
            {menuItems.map((item) => (
              <li key={item.id} className="mb-1 px-2">
                {item.hasSubmenu ? (
                    <div>
                    <div className="flex items-center justify-between">
                        <Link
                        to="/hr"
                        onClick={() => setActiveMenuItem(item.id)}
                        className={`
                            flex items-center
                            w-full p-3 
                            rounded-lg 
                            transition-colors 
                            duration-200
                            ${isHrActive || activeMenuItem === item.id
                            ? 'bg-primary-900 text-white' 
                            : 'text-primary-100 hover:bg-primary-700'
                            }
                        `}
                        >
                        <span className="inline-flex shrink-0">{item.icon}</span>
                        {(expanded || (isMobile && isOpen)) && (
                            <motion.span
                            initial={{ opacity: 0, x: -10 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -10 }}
                            className="ml-4 whitespace-nowrap overflow-hidden"
                            >
                            {item.title}
                            </motion.span>
                        )}
                        </Link>
                        <motion.button
                        onClick={(e) => {
                            e.stopPropagation(); // Prevent the link from triggering
                            setHrDropdownOpen(!hrDropdownOpen);
                        }}
                        className="p-1 rounded-full hover:bg-primary-700 focus:outline-none"
                        aria-label="Toggle HR submenu"
                        >
                        <motion.div
                            animate={{ rotate: hrDropdownOpen ? 180 : 0 }}
                            transition={{ duration: 0.2 }}
                        >
                            <ChevronDown className="w-4 h-4" />
                        </motion.div>
                        </motion.button>
                    </div>
                    <AnimatePresence>
                        {hrDropdownOpen && (expanded || (isMobile && isOpen)) && (
                        <motion.ul
                            initial={{ opacity: 0, maxHeight: 0 }}
                            animate={{ opacity: 1, maxHeight: 250 }}
                            exit={{ opacity: 0, maxHeight: 0 }}
                            transition={{ duration: 0.2 }}
                            className="ml-4 mt-2 space-y-1 overflow-y-auto"
                        >
                            {item.submenuItems.map((subItem) => (
                            <motion.li
                                key={subItem.id}
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -10 }}
                            >
                                <Link
                                to={subItem.path}
                                onClick={() => {
                                    setActiveMenuItem(subItem.id);
                                    if (isMobile) setIsOpen(false);
                                }}
                                className={`
                                    block px-3 py-2 
                                    rounded-lg 
                                    text-sm 
                                    transition-colors 
                                    duration-200
                                    ${location.pathname === subItem.path
                                    ? 'bg-primary-700 text-white' 
                                    : 'text-primary-100 hover:bg-primary-700'
                                    }
                                `}
                                >
                                {subItem.title}
                                </Link>
                            </motion.li>
                            ))}
                        </motion.ul>
                        )}
                    </AnimatePresence>
                    </div>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => handleMenuClick(item.id)}
                    className={`
                      flex items-center 
                      w-full p-3 
                      rounded-lg 
                      transition-colors 
                      duration-200
                      ${activeMenuItem === item.id 
                        ? 'bg-primary-900 text-white' 
                        : 'text-primary-100 hover:bg-primary-700'
                      }
                    `}
                  >
                    <span className="inline-flex shrink-0">{item.icon}</span>
                    {(expanded || (isMobile && isOpen)) && (
                      <motion.span
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -10 }}
                        className="ml-4 whitespace-nowrap overflow-hidden"
                      >
                        {item.title}
                      </motion.span>
                    )}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Profile section */}
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-primary-700">
          <div className="flex items-center">
            <div className="w-9 h-9 rounded-full bg-primary-600 flex items-center justify-center text-primary-100 font-medium">
              JS
            </div>
            <AnimatePresence mode="wait">
              {(expanded || (isMobile && isOpen)) && (
                <motion.div
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -10 }}
                  className="ml-3 overflow-hidden"
                >
                  <p className="text-sm font-medium text-white">John Smith</p>
                  <p className="text-xs text-primary-300">Admin</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default DashboardSidebar;

